<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" :title="title" @back="back">
            <common-training-header />
        </a-page-header>

        <div class="text-right" style="margin-bottom: 24px">
            <a-button type="primary" icon="plus" @click="addForm()" v-if="showing && !editing"> Tambah</a-button>
        </div>

        <a-card type="inner" size="small" style="margin-bottom: 12px">
            <a-skeleton :loading="preload" active>
                <a-form-model :model="formData" :label-col="labelCol" :wrapper-col="wrapperCol" ref="ruleForm" :rules="rules" labelAlign="left">
                    <a-form-model-item label="Pegawai" prop="attendants" v-if="type != 'mentoring'">
                            <a-select v-model="formData.attendants[0]" style="width: 30%">
                                <a-select-option
                                    v-for="d in peserta"
                                    :key="d.members[0].member_id"
                                    :value="d.members[0].member_id"
                                >
                                    {{ d.name }}
                                </a-select-option>
                            </a-select>
                    </a-form-model-item>
                    <div v-if="type == 'mentoring'">
                        <a-form-model-item label="Peserta" prop="attendants">
                                <a-table
                                    :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                                    :columns="columns"
                                    :data-source="peserta"
                                    :rowKey="record => record.members[0].member_id"
                                    :pagination="false"
                                    :scroll="{ y: 250 }"
                                >
                                    <div slot="name" slot-scope="record">
                                        {{ record.name }}
                                    </div>

                                    <div slot="position" slot-scope="record">
                                        {{ record.members[0].position.name }}
                                    </div>
                                </a-table>
                        </a-form-model-item>
                        <a-form-model-item label="Mentor" prop="cmc_mentor" >
                                <a-input v-model="formData.cmc_mentor" />
                        </a-form-model-item>
                    </div>

                    <div v-if="type == 'counceling'">
                        <a-form-model-item label="Konselor" prop="cmc_mentor" >
                                <a-input v-model="formData.cmc_mentor" />
                        </a-form-model-item>
                    </div>

                    <a-form-model-item label="Tanggal" prop="cmc_date">
                            <a-date-picker
                                v-model="formData.cmc_date"
                                @change="onStartDateChange"
                                :format="'YYYY-MM-DD'"
                                type="date"
                                placeholder="Pick a date"
                            />
                    </a-form-model-item>

                    <a-form-model-item label="Waktu Mulai" prop="time_start">
                        <a-time-picker
                            v-model="formData.time_start"
                            :format="'HH:mm:ss'"
                            :valueFormat="'HH:mm:ss'"  />
                    </a-form-model-item>
                    <a-form-model-item label="Waktu Berakhir" prop="time_end">
                            <a-time-picker
                                v-model="formData.time_end"
                                :valueFormat="'HH:mm:ss'" />
                    </a-form-model-item>
                    <a-form-model-item label="Judul Bahasan" prop="cmc_topic" >
                            <a-input v-model="formData.cmc_topic" />
                    </a-form-model-item>
                    <a-form-model-item :label="`Area ${labels[type]}`" prop="cmc_category">
                        <a-select v-model="formData.cmc_category" style="width: 30%">
                            <a-select-option v-for="(cat, catKey) in categories" :value="catKey" :key="catKey">
                                {{ cat }}
                            </a-select-option>
                        </a-select>
                    </a-form-model-item>

                    <div v-if="type == 'coaching'">
                        <a-form-model-item label="Goal (Tujuan)" prop="coach_goal">
                                <a-textarea v-model="formData.coach_goal" :rows="4" />
                        </a-form-model-item>
                        <a-form-model-item label="Reality (Kebutuhan yang terungkap)" prop="coach_reality">
                                <a-textarea v-model="formData.coach_reality" :rows="4" />
                        </a-form-model-item>
                        <a-form-model-item label="Option (Pilihan Selesai)" prop="coach_option">
                                <a-textarea v-model="formData.coach_option" :rows="4" />
                        </a-form-model-item>
                        <a-form-model-item label="Will (Tindakan keputusan yang diambil)" prop="coach_will">
                                <a-textarea v-model="formData.coach_will" :rows="4" />
                        </a-form-model-item>
                    </div>

                    <div v-if="type == 'mentoring'">
                        <a-form-model-item label="Kompetensi" prop="mentoring_competency" >
                                <a-input v-model="formData.mentoring_competency" />
                        </a-form-model-item>
                        <a-form-model-item label="Aspek Kompetensi" prop="mentoring_aspect" >
                                <a-input v-model="formData.mentoring_aspect" />
                        </a-form-model-item>
                        <a-form-model-item label="Tahapan Mentoring" prop="mentoring_steps" >
                                <a-input v-model="formData.mentoring_steps" />
                        </a-form-model-item>
                        <a-form-model-item label="Metode/Cara Mentoring" prop="mentoring_method" >
                                <a-input v-model="formData.mentoring_method" />
                        </a-form-model-item>
                        <a-form-model-item label="Target Waktu" prop="mentoring_way" >
                                <a-date-picker
                                    show-time
                                    :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
                                    @change="onTargetDateChange"
                                    :format="'YYYY-MM-DD HH:mm:ss'"
                                    v-model="formData.cmc_time_target"
                                    type="date"
                                />
                        </a-form-model-item>
                        <a-form-model-item label="Cara Monitoring" prop="mentoring_way" >
                                <a-input v-model="formData.mentoring_way" />
                        </a-form-model-item>
                        <a-form-model-item label="Key Performance" prop="mentoring_kpi" >
                                <a-input v-model="formData.mentoring_kpi" />
                        </a-form-model-item>
                    </div>

                    <div v-if="type == 'counceling'">
                        <a-form-model-item label="Object/Aspek Konseling" prop="counseling_object" >
                                <a-input v-model="formData.counseling_object" />
                        </a-form-model-item>
                        <a-form-model-item label="Langkah-langkah" prop="counseling_steps" >
                                <a-input v-model="formData.counseling_steps" />
                        </a-form-model-item>
                        <a-form-model-item label="Progress" prop="counseling_progress" >
                                <a-input v-model="formData.counseling_progress" />
                        </a-form-model-item>
                    </div>

                    <a-form-model-item label="Kategori" prop="category">
                            <a-radio-group name="category" :default-value="1" v-model="formData.category">
                                <a-radio value="teknis">
                                Teknis
                                </a-radio>
                                <a-radio value="non teknis">
                                Non Teknis
                                </a-radio>
                            </a-radio-group>
                    </a-form-model-item>
                    <a-form-model-item>
                        <a-row type="flex" justify="center" align="top">
                            <a-col>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="handleSubmit"
                                    >Simpan</a-button>
                            </a-col>
                        </a-row>
                    </a-form-model-item>
                </a-form-model>
            </a-skeleton>
        </a-card>

        <performance-cmc-documentation :type="type" :title="title" :cmc="cmc" v-if="showing" />

    </div>
</template>

<script>
const columns = [
    {
        key: 'name',
        title: 'Nama',
        scopedSlots: {customRender: 'name'},
    },
    {
        key: 'position',
        title: 'Posisi',
        scopedSlots: {customRender: 'position'},
    },
];

export default {
    props: {
        cmc: {
            type: String,
            default: ''
        },
        edit: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    data () {
        let attendantRule = (rule, value, callback) => {
            if (value.length < 1) {
                callback(new Error('Wajib pilih salah satu'));
            } else {
                callback();
            }
        };
        return {
            columns,
            selectedRowKeys: [],
            loading: false,
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
            form: this.$form.createForm(this),
            formData: {
                attendants: [],
                type: 'coaching',
                timeStart: null,
                timeEnd: null
            },
            peserta: {},
            processing: false,
            preload: false,
            rules: {
                attendants: [
                    { required: true, validator: attendantRule, trigger: 'change' },
                ],
                cmc_mentor: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                cmc_date: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                time_start: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                time_end: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                cmc_topic: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                cmc_category: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                coach_goal: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                coach_reality: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                coach_option: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                coach_will: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_competency: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_aspect: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_steps: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_way: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_method: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                mentoring_kpi: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                counseling_object: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                counseling_steps: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                counseling_progress: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
                category: [
                    { required: true, message: 'Wajib diisi', trigger: 'change' },
                ],
            },
            labels: {
                coaching: 'Coaching',
                mentoring: 'Mentoring',
                counceling: 'Counceling'
            },
            categories: {
                business_process: 'Business Process',
                business_result: 'Business Result',
                soft_competency: 'Soft Competency',
                paper: 'Makalah',
                project_management: 'Project Management'

            }
        }
    },
    created() {
        this.preload = true;
        this.fetchPeserta()
        if (this.showing) {
            this.fetchCMC()
        }

        if(this.type != 'coaching' && !this.showing){
            this.formData.cmc_mentor = this.activeUser.name
        }
    },
    computed: {
        showing(){
            return this.cmc !== ""
        },
        editing(){
            return this.edit !== ""
        },
        activeUser() {
            return this.$laravel.user
        }
    },
    methods: {
        fetchPeserta() {
            this.$http
                .get(
                    this.routeUri("api.training-members"),{
                        params: {
                            parent: 'mentor',
                            parent_hash: this.activeUser.hash,
                            is_attendant: 1
                        }
                    }
                )
                .then(res => (this.peserta = res.data.members))
                .finally(() => (this.preload = false));
        },
        fetchCMC() {
            this.$http
                .get(
                    this.routeUri("api.cmc.show", { type: this.type, cmc: this.cmc}))
                .then(res => (this.formData = res.data))
                .finally(() => (this.preload = false));
        },
        handleSubmit(e) {
            this.processing = true;

            let promise;

            if(_.isObject(this.formData.time_start)){
                this.formData.time_start = this.formData.time_start.format('HH:mm:ss')
            }
            if(_.isObject(this.formData.time_end)){
                this.formData.time_end = this.formData.time_end.format('HH:mm:ss')
            }

            promise = this.$http.put(
                this.routeUri("api.cmc.update", { type: this.type, cmc: this.cmc }),
                this.formData
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";


            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage,
                onClose: () => window.location.reload(),
            });

            let params = {
                type: this.type,
                title: this.title,
                cmc: data.cmc.id
            }


        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        onStartDateChange(date, dateString) {
            this.formData.cmc_date = dateString
        },
        back() {
            window.location.href = this.routeUri('admin.performance.' + this.type)
        },
        handleClose() {
            this.$emit("handleClose", false);
        },
        onSelectChange(selectedRowKeys) {
            this.formData.attendants = selectedRowKeys;
            this.selectedRowKeys = selectedRowKeys;
        },
        addForm(){
            let params = {
                type: this.type,
                title: this.title
            }
            window.location.href = this.routeUri("admin.performance.cmc.form") + '?' + this.$qs.stringify(params)
        },
        onTargetDateChange(date, dateString) {
            this.formData.cmc_time_target = dateString
        },
    },
    watch: {
        formData: {
            deep: false,
            handler: function(value) {

                this.formData.time_start = this.moment(value.time_start, "HH:mm:ss")
                this.formData.time_end = this.moment(value.time_end, "HH:mm:ss")

                if(this.type == 'coaching'){
                    this.formData.attendants[0] = value.attendants[0].id
                }

                if(this.type == 'counceling'){
                    this.formData.attendants[0] = value.attendants[0].id
                }

                if(this.type == 'mentoring'){
                    let vm = this
                    let newAttendants = []
                    value.attendants.forEach(function (item, index) {
                        newAttendants.push(item.id)
                        vm.selectedRowKeys.push(item.id)
                    })

                    this.formData.attendants = newAttendants
                }
            }
        }
    }
}
</script>
